import { render, staticRenderFns } from "./SettingRevisions.vue?vue&type=template&id=e88d5108"
import script from "./SettingRevisions.vue?vue&type=script&lang=js"
export * from "./SettingRevisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports